import { Outlet } from 'react-router-dom';
import { useAllOperationMethods, useUserProfileDialog } from '@/widgets';
import { AuthorizedLayoutHeader } from './AuthorizedLayoutHeader';
import { SidebarNavigation } from './sidebar';
import { cn } from '@/shared/utils';
import { usePullToRefresh } from '@/shared/lib';
import { useInternalTransferModals } from '@/features/internal-transfer';
import {
  useAccountActionsVisibility,
  useSyncAccountsStore,
} from '@/entities/account';
import { useUserScopeConfigurationFull } from '@/entities/user';
import {
  useAccountsAndOperationsRefresh,
  useSyncPendingAccounts,
} from './model';
import PullToRefresh from 'react-simple-pull-to-refresh';

const AuthorizedLayout = () => {
  useSyncPendingAccounts();
  useSyncAccountsStore();
  useAccountsAndOperationsRefresh();
  useUserScopeConfigurationFull();

  const { depositMethods, withdrawMethods } = useAllOperationMethods();
  const { visibility } = useAccountActionsVisibility();
  const { openUserProfileDialog } = useUserProfileDialog();

  const { openInternalTransferFormModal } = useInternalTransferModals();

  const { handleRefresh, isMobile } = usePullToRefresh();

  return (
    <PullToRefresh
      onRefresh={handleRefresh}
      isPullable={isMobile}
      pullingContent={''}
      className="overflow-y-auto bg-secondary-bg">
      <div className="flex flex-row w-screen h-dvh overflow-hidden">
        <main className="grow flex flex-col bg-secondary-bg overflow-hidden ">
          <AuthorizedLayoutHeader
            onDepositClick={depositMethods.openOperationMethodsModal}
            onWithdrawClick={withdrawMethods.openOperationMethodsModal}
            onTransferClick={openInternalTransferFormModal}
            onSettingsClick={openUserProfileDialog}
            buttonsVisibility={{
              deposit: visibility.deposit,
              withdraw: visibility.withdraw,
              transfer: visibility.transfer,
            }}
          />
          <div className="flex flex-row overflow-hidden">
            <div className="hidden tablet:block mt-[11rem] min-w-[29rem] w-[29rem] h-[calc(100dvh-11rem)] fixed left-0 top-0 z-1">
              <SidebarNavigation />
            </div>
            <div
              className={cn(
                'flex-1 overflow-y-auto overflow-x-hidden relative tablet:ml-[29rem] tablet:pl-[1rem] pt-[8.6rem]',
                isMobile && 'pb-[4.2rem]'
              )}>
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </PullToRefresh>
  );
};

export { AuthorizedLayout };
